export default "__VITE_ASSET__C9uP$D93__"